import { useInfiniteQuery } from "@tanstack/react-query";
import { useAuth } from "../../../contexts/auth/Context";
import { getSubscriptionsRequest } from "../../requests/subscription";
import type { GetSubscriptionsParams } from "../../requests/subscription";
import { CACHE_TIMES } from "../../../query/options";

interface UseInfiniteSubscriptionsOptions {
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
  refetchOnMount?: boolean;
}

export const useInfiniteSubscriptions = (
  params: Omit<GetSubscriptionsParams, "page"> = {},
  options: UseInfiniteSubscriptionsOptions = {},
) => {
  const { token } = useAuth();
  const { enabled = true, ...cacheOverrides } = options;

  return useInfiniteQuery({
    queryKey: ["subscriptions", "infinite", params],
    queryFn: ({ pageParam }) =>
      getSubscriptionsRequest(token!, { ...params, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.currentPage < lastPage.meta.totalPages
        ? lastPage.meta.currentPage + 1
        : undefined,
    enabled: Boolean(token) && enabled,
    ...CACHE_TIMES.MASTER_DATA,
    ...cacheOverrides,
  });
};
